import { PassportFilesResource } from '@backend/agents-ui-api/resources/student-document/passport/types'
import { ApiAgentRequest, request } from '../utils'

export type RawGetPassportFileResponse = {
  data: PassportFilesResource
}

export async function getPassportFile(studentId?: string, passportId?: string) {
  return request<RawGetPassportFileResponse>(
    new ApiAgentRequest(`/students/${studentId}/passports/${passportId}/file`, {
      method: 'GET',
    }),
    {
      isExpectedResponse: (res): res is RawGetPassportFileResponse => res as boolean,
    },
  )
}
